export default __webpack_public_path__ + "static/media/06.1439e4e6.jpg";